export const EditorTabs = {
  DETAILS: "story-detail",
  TABLE_OF_CONTENTS: "toc",
  NOTES: "story-planner"
};
